import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { Subject } from 'rxjs';

@Injectable()
export class FormService {
    _formEvents = new Subject<any>();
    formGroup: RxFormGroup;

    get form(): RxFormGroup { return this.formGroup; }

    constructor(private formBuilder: RxFormBuilder) { }

    fire(data: any): any {
        this._formEvents.next(data);
    }

    transformIntoFormGroup(model: any, data: any): void {
        this.formGroup = this.formBuilder.formGroup(model, data) as RxFormGroup;
        this.fire(this.formGroup);
    }
}
